<template>
  <transition name="slide">
    <div class="hs-container-child" v-if="show">
      <c-header class="c-header-new" leftIcon1="icons_24pt_back.png" :leftFn1="close" :title="$t('Department')" />

      <hs-search-bar-new
          className="style2"
          v-model="KeyWord"
          :placeholder="$t('Search_1')"
          :hasClear="!!KeyWord"
          @clear="KeyWord = ''"
      />
      <hs-scroll
        class="table-view"
        ref="tableView"
        :data="datalist"
        :options="tableViewOptions"
        @pulling-down="_getDatalist"
        @pulling-up="_getDatalistMore">
        <ul>
          <hs-null
              v-if="datalist.length <= 0"
              style="padding-top: calc(40dvh - 88px)"
              styleType="empty"
              :title="$t('NoDataContent')"
          />
          <cost-centers-item
              v-for="(item, index) in datalist"
              :key="index"
              :active="_getIsActive(item)"
              :item="item"
              @click.native="_select(item)"
          />
          <hs-all-load-text v-if="datalist.length" />
        </ul>
      </hs-scroll>
    </div>
  </transition>
</template>
<script type="text/ecmascript-6">
import CHeader from 'components/c-header/c-header'
import HsScroll from 'base/hs-scroll/hs-scroll'
import HsSection from 'base/hs-tableview/hs-section/hs-section'
import HsCell1 from 'base/hs-tableview/hs-cell-1/hs-cell-1'
import {kpiUserGetDepartments} from 'api'
import HsNull from "@/base/hs-null/hs-null.vue";
import HsSearchBarNew from "@/base/hs-search-bar/hs-search-bar-new.vue";
import CostCentersItem from "@/pages/personal/passengers/passenger-details/cost-centers-item.vue";
import HsAllLoadText from "@/base/hs-null/hs-all-load-text.vue";
export default {
  props: {
    details: {
      type: Object,
      default: function() {
        return {}
      }
    },
    selected: {
      type: Object,
      default: function() {
        return {}
      }
    },
  },
  data() {
    return {
      show: false,
      tableViewOptions: {
        pullDownRefresh: {
          threshold: 50
        },
        pullUpLoad: false
      },
      currentPageIndex: 1,
      currentPageSize: 20,
      datalist: [],
      KeyWord: ''
    }
  },
  watch: {
    show(val) {
      if (val) {
        this._getDatalist()
      } else {
        this.KeyWord = ''
        this.$nextTick(() => {
          this.timer && clearTimeout(this.timer); // eslint-disable-line
        })
      }
    },
    KeyWord(val) {
      this.timer && clearTimeout(this.timer); // eslint-disable-line
      this.timer = setTimeout(() => {
        this._getDatalist()
      }, 500)
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
    _getDatalist() {
      this.currentPageIndex = 1
      this.tableViewOptions.pullUpLoad = false
      let params = {
        PageIndex: this.currentPageIndex,
        PageSize: this.currentPageSize,
        KeyWord: this.KeyWord
      }
      console.log('----------', this.details)
      if (this.details.ID) {
        params.UpID = this.details.ID
      }

      if (this.details.UpID) {
        params.UpID = this.details.UpID
      }
      kpiUserGetDepartments(params).then((res) => {
        console.log('部门: ', res)
        this.datalist = res.ResultData || []
        if (!this.KeyWord) {
          this.datalist.unshift({
            Name: this.$t('DoNotChooseForNow'),
            ID: null,
          })
        }
        if (res.ResultData.length >= this.currentPageSize) {
          this.tableViewOptions.pullUpLoad = {threshold: 50}
        }
        this.$refs.tableView && this.$refs.tableView.forceUpdate();
      })
    },
    _getDatalistMore() {
      let params = {
        PageIndex: this.currentPageIndex + 1,
        PageSize: this.currentPageSize,
        KeyWord: this.KeyWord
      }
      console.log('----------', this.details)
      if (this.details.ID) {
        params.UpID = this.details.ID
      }

      if (this.details.UpID) {
        params.UpID = this.details.UpID
      }
      kpiUserGetDepartments(params).then((res) => {
        console.log('部门: ', res)
        this.currentPageIndex++
        this.datalist = this.datalist.concat(res.ResultData)
        if (res.ResultData.length < this.currentPageSize) {
          this.tableViewOptions.pullUpLoad = false
        } else {
          this.tableViewOptions.pullUpLoad = {threshold: 50}
        }
        this.$refs.tableView && this.$refs.tableView.forceUpdate();
      })
    },

    /** 获取当前项是否选中 */
    _getIsActive(item) {
      // 转小写在比较
      return this.selected && this.selected.ID && item.ID && this.selected.ID.toLowerCase() === item.ID.toLowerCase()
    },

    _select(item) {
      this.$emit('select', item.ID === null ? null : item)
      this.close()
    }
  },
  components: {
    HsAllLoadText, CostCentersItem,
    HsSearchBarNew,
    HsNull,
    CHeader,
    HsScroll,
    HsSection,
    HsCell1
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-container-child
  @extend .flex-column
  @extend .flex-start
  position absolute
  width 100%
  height 100%
  left 0
  top 0
  bottom 0
  background-color $color_white
  z-index 200
  .table-view
    width 100%
    height calc(100% - 48px - 56px)
    overflow hidden
    background-color $color_white
</style>
